'use strict';
import $ from 'jquery';

export default class Amplitude {
    static init() {
        $('a').each((index, el) => {
            if ($(el).attr('href') && $(el).attr('href').match('https?://app.getblueshift.com/users/sign_up')) {
                new Amplitude($(el));
            }
        });
    }

    getAnonymousID() {
        const self = this;
        window.analytics.ready(function () {
            window.analytics?.track("Anonymous Action", {
                entity_name: "corporate_website",
                entityType: "pricing_page",
            });

            const anonymousId = analytics.user().anonymousId()
            self.anonymousId = anonymousId;
            self.allowClicks = true;
            clearTimeout(self.timer);
        });
    }

    timer() {
        this.timer = setTimeout(() => {
            this.allowClicks = true;
        }, 2000);
    }

    constructor($el) {
        this.el = $el;
        this.anonymousId = false;
        this.allowClicks = false;
        this.getAnonymousID();
        this.timer();
        this.el.on('click', this.bindClick.bind(this));
    }

    bindClick(e) {
        if (this.allowClicks) {
            if (this.anonymousId)
                this.el.attr('href', this.el.attr('href') + (this.el.attr('href').match(/\?/) ? '&' : '?') + 'anonymousIID=' + this.anonymousId);
        } else {
            return false;
        }
    }
}